import { createAction, props } from '@ngrx/store';

export enum CoreAction {
	SetUserAdminRole = '[AngularJS] Set User Admin Role',
	SetCurrentUserId = '[AngularJS] Set Connected User Id',
	GoToGdHome = '[Core] Go to generics data project home page',
	GoToHdHome = '[Core] Go to handle data project home page',
	GoToProjects = '[Core] Go to projects page',
	SetProject = '[Core] Select Project',
}

export const setUserAdminRole = createAction(
	CoreAction.SetUserAdminRole,
	props<{ isAdmin: boolean }>()
);

export const setCurrentUserId = createAction(
	CoreAction.SetCurrentUserId,
	props<{ userId: string }>()
);

export const goToGdHome = createAction(CoreAction.GoToGdHome);

export const goToHdHome = createAction(CoreAction.GoToHdHome);

export const goToProjects = createAction(CoreAction.GoToProjects);

export const setProject = createAction(
	CoreAction.SetProject,
	props<{ projectId: number; projectLabel: string }>()
);
